import decimal from './decimal';

const decimalLeadingZero = decimal.withPadLeft(2, '0');

export default decimalLeadingZero;
